import './action-bar.scss';

import { faClock, faListAlt } from '@fortawesome/free-regular-svg-icons';
import {
    faClock as faSolidClock,
    faCogs,
    faHome,
    faListAlt as faSolidListAlt,
    faWifi,
    faSlash,
    faExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { Component, Watch } from 'vue-property-decorator';

import { MovementDataStore, TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { SideMenu } from '@skinsoft/ui';
import { FORCE_CLOSE_MENU_TOPIC } from '../../../busTopics';
import { router, Routes } from '../../../router';
import { SynchroModal } from '@skinsoft/offline-mode';
import { OnlineStatusIndicator } from '@skinsoft/offline-mode/src/components/online-status-indicator';
import { OfflineDataUpdateCacher } from '@skinsoft/data-store/src/offline/offline-data-update-cacher';
import { OfflineDataFetcher } from '@skinsoft/data-store';
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics';

@Component({
    components: {
        sSideMenu: SideMenu,
        sSynchroModal: SynchroModal,
        sOnlineStatusIndicator: OnlineStatusIndicator,
    },
    template: require('./action-bar.html'),
})
export class ActionBar extends ReactiveVue {
    public $refs: {
        synchroModal: SynchroModal
    }

    public homeIcon = faHome;
    public menuIcon = faCogs;
    public clockIcon = faClock;
    public solidClockIcon = faSolidClock;
    public listIcon = faListAlt;
    public solidListIcon = faSolidListAlt;
    public wifiIcon = faWifi;
    public slashIcon = faSlash;
    public errorIcon = faExclamation;
    public $route;

    public movementCount: number = 0;
    public taskCount: number = 0;
    public menuOpened: boolean = false;
    public routeHasMenu: boolean = false;

    public $movementDataStore: MovementDataStore;
    public $taskDataStore: TaskDataStore;

    public toggleSideMenuTopic = TOGGLE_MENU_TOPIC;
    public forceCloseMenuTopic = FORCE_CLOSE_MENU_TOPIC;
    private isSyncError: boolean = false;

    public created() {
        this.subscribeToBus(TOGGLE_MENU_TOPIC, () => {
            this.menuOpened = !this.menuOpened;
        })
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    public goToCurrentReports() {
        router.push({ name: Routes.CURRENT_REPORTS });
    }

    public goToCloseReports() {
        router.push({ name: Routes.CLOSE_REPORTS });
    }

    public goToSearch() {
        router.push({ name: Routes.CONDITION_REPORT_HOME });
    }

    public toggleMenu() {
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    private toogleSynchroModal() {
        this.$refs.synchroModal.open();
    }

    private async fetchSyncError() {
        this.isSyncError = await OfflineDataUpdateCacher.isPushError() || await OfflineDataFetcher.isSyncError();
    }

    private checkCurrentRoute(routeName) {
        return this.$route.path === routeName;
    }

    @Watch('$route', { immediate: true, deep: true })
    private onRouteChange($route) {
        this.routeHasMenu = !!$route.matched.find(match => !!match.components.actionMenu);
        if (!this.routeHasMenu) {
            this.emitOnBus(FORCE_CLOSE_MENU_TOPIC);
            this.menuOpened = false;
        }
    }
}
